import Vue from 'vue'
import VueI18n from 'vue-i18n'
import de from '@/locales/de.json'
import en from '@/locales/en.json'
import tr from '@/locales/tr.json'

Vue.use(VueI18n)

const LOCALE_KEY = 'backoffice_locale'
const SUPPORTED = ['de', 'en', 'tr']

const saved = localStorage.getItem(LOCALE_KEY)
const locale = SUPPORTED.includes(saved) ? saved : 'de'

export const i18n = new VueI18n({
  locale,
  fallbackLocale: 'de',
  messages: { de, en, tr },
  silentFallbackWarn: true
})

export function setLocale (lang) {
  i18n.locale = lang
  localStorage.setItem(LOCALE_KEY, lang)
}
